import React from "react";
import BG from "../../assets/rebg.svg";
import REHOUSE from "../../assets/Chyson Food page.png";
import TextFade from "../../components/CustomTexts/TextFade";
import Button from "../../components/Buttons/Button";
import RealEstateCollection from "./RealEstateCollection";
import WhyChooseUsRealEstate from "./WhyChooseUsRealEstate";
import CallToActionSection from "../../components/Others/CallToActionSection";
import TextEffect from "../../components/CustomTexts/TextEffect";

const RealEstatePage = () => {
  return (
    <div>
      <div
        className="relative h-[110vh] flex md:flex-row flex-col justify-between items-center bg-white w-full bg-no-repeat bg-cover md:gap-0 gap-20 overflow-hidden"
        style={{
          backgroundImage: `url('${BG}')`,
          backgroundPosition: "bottom",
        }}
      >
        {/* Green Overlay */}
        <div className="absolute inset-0 bg-green-400/80 z-0" />

        {/* Desktop Image */}
        <div className="hidden md:block absolute bottom-0 right-0 z-[2]">
          <img
            src={REHOUSE}
            alt="building"
            className="w-[750px] lg:w-[950px] xl:w-[1000px] object-contain pointer-events-none select-none"
          />
        </div>

        {/* Mobile Image */}
        <div className="block md:hidden absolute bottom-0 right-[-30px] z-[1]">
          <img
            src={REHOUSE}
            alt="Hero Mobile Visual"
            className="w-[450px] sm:w-[400px] object-contain pointer-events-none select-none"
          />
        </div>

        {/* Text Content */}
        <div className="relative z-10 w-full md:w-[50%] px-4 md:px-[5%] pt-40 md:pt-0 text-center md:text-left flex flex-col justify-center gap-6 md:gap-10 items-center md:items-start">
          <TextFade animation="fade-up">
            <h1 className="font-bold text-white leading-tight">
              <TextEffect
                part1="Chyson"
                responsiveSize="text-[4.9rem] sm:text-[4.9rem] md:text-[5rem] lg:text-[6rem] xl:text-[6.5rem]"
              />
              <br />
              <TextEffect
                part2="Foods"
                responsiveSize="text-[4.9rem] sm:text-[4.9rem] md:text-[5rem] lg:text-[6rem] xl:text-[6.5rem]"
              />
            </h1>
          </TextFade>

          <p className="text-light text-sm sm:text-base md:text-lg xl:text-xl w-full md:w-[90%] leading-relaxed">
Chyson Foods is our dedicated food processing arm, offering a variety of healthy, OFSP-based products like fresh tubers, flours, fries, granules, chips, and bakery items—bringing taste and nutrition together in every bite.          </p>

          <div className="flex justify-center md:justify-start w-full mt-4">
            <Button value="View our products" url="/services/chyson-foods/#collection" />
          </div>
        </div>
      </div>

      <RealEstateCollection id="collection" />
      <WhyChooseUsRealEstate />
      <CallToActionSection />
    </div>
  );
};

export default RealEstatePage;
